const updates = [
  {
    date: '2024.07.30',
    title: '《歌手 2024》总决赛完整版上线',
    desc: '巅峰对决之夜，华语乐坛顶级歌手终极竞演，1080P超清完整版已更新。',
    icon: 'ri-music-2-fill',
    tag: '最新上线',
  },
  {
    date: '2024.07.29',
    title: '《奔跑吧》第十二季第8期更新',
    desc: '明星嘉宾趣味运动会特辑，爆笑挑战环节全新升级，精彩不容错过。',
    icon: 'ri-run-fill',
    tag: '今日更新',
  },
  {
    date: '2024.07.28',
    title: '《密室大逃脱》第五季开播',
    desc: '全新密室主题，更烧脑的谜题设计，嘉宾阵容全面升级，首播即获好评。',
    icon: 'ri-key-2-fill',
    tag: '新季首播',
  },
  {
    date: '2024.07.27',
    title: '《脱口秀大会》第六季第5期上线',
    desc: '新老脱口秀演员同台竞技，犀利吐槽与温暖故事兼具，笑中带泪。',
    icon: 'ri-emotion-laugh-fill',
    tag: '热门更新',
  },
  {
    date: '2024.07.26',
    title: '《这！就是街舞》总决赛回顾特辑',
    desc: '年度街舞盛典全记录，全球顶尖舞者齐聚，炸裂舞台合集一次看过瘾。',
    icon: 'ri-footprint-fill',
    tag: '经典回顾',
  },
  {
    date: '2024.07.25',
    title: '平台新增智能推荐功能',
    desc: '根据你的观看偏好，智能推荐你可能喜欢的综艺节目，发现更多精彩内容。',
    icon: 'ri-robot-fill',
    tag: '功能更新',
  },
  {
    date: '2024.07.24',
    title: '《向往的生活》收官特辑暖心上线',
    desc: '本季最温暖的收官之作，回顾一路走来的感动瞬间，弹幕互动火热进行中。',
    icon: 'ri-heart-fill',
    tag: '暖心收官',
  },
  {
    date: '2024.07.23',
    title: '移动端深色护眼模式正式上线',
    desc: '夜间追综更舒适，自动适配系统深色模式，保护视力享受沉浸式观影。',
    icon: 'ri-moon-fill',
    tag: '体验升级',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            最新动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            极速影院最新节目更新与平台动态一览
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-3 bottom-3 w-px bg-background-200 hidden sm:block"></div>

          <div className="space-y-5">
            {updates.map((item, index) => (
              <div key={index} className="flex gap-4 sm:gap-5">
                <div className="relative z-10 w-10 h-10 rounded-xl bg-primary-500 flex items-center justify-center flex-shrink-0 hidden sm:flex">
                  <i className={`${item.icon} text-background-50 text-base`}></i>
                </div>

                <div className="flex-1 bg-background-100 rounded-xl p-4 sm:p-5">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-[11px] text-foreground-500 font-medium">{item.date}</span>
                    <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-bold">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-950 font-heading">{item.title}</h3>
                  <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}